import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { useCallback, cloneElement } from 'react';
import MoaStyledComponent from "../../Style/MoaStyled";
import IconButton from '@mui/material/IconButton';
import Color from '../../Style/Color';
import { MarginProps } from '../../Style/Margin';
import { PaddingProps } from '../../Style/Padding';
import { Icon } from '../../';
var StyledComponent = styled(function (props) {
    var id = props.id, sx = props.sx, children = props.children, iconName = props.iconName, color = props.color, transparent = props.transparent, transparentColor = props.transparentColor, border = props.border, rest = __rest(props, ["id", "sx", "children", "iconName", "color", "transparent", "transparentColor", "border"]);
    if (sx)
        console.error('The sx prop is not used in StyledComponent');
    var CustomBackgroundColor = useCallback(function (_a) {
        var color = _a.color, transparent = _a.transparent;
        //color === "normal"
        var normalStyle = {
            border: "1px solid ".concat(Color.primary.enable_strock),
            background: Color.primary.enable,
            color: Color.text.primary,
            "&:hover": {
                background: Color.primary.hover,
                color: Color.primary.white,
            },
            ":active": {
                background: Color.primary.focus,
                color: Color.primary.white,
            },
            ":disabled": {
                background: "".concat(Color.primary.enable, "c0"),
                color: "".concat(Color.text.disable, "c0"),
                border: "1px solid ".concat(Color.primary.enable_strock, "c0"),
            },
        };
        var negativeStyle = color === "negative" ? {
            border: "1px solid ".concat(Color.primaryNegative.enable_strock),
            background: Color.primaryNegative.enable,
            color: Color.textNegative.primary,
            "&:hover": {
                background: Color.primaryNegative.hover,
                color: Color.primaryNegative.white,
            },
            ":active": {
                background: Color.primaryNegative.focus,
                color: Color.primaryNegative.white,
            },
            ":disabled": {
                background: "".concat(Color.primaryNegative.enable, "c0"),
                color: "".concat(Color.textNegative.disable, "c0"),
                border: "1px solid ".concat(Color.primaryNegative.enable_strock, "c0"),
            },
        } : {};
        var transparentStyle = transparent ? {
            border: 'none',
            background: "transparent",
            color: transparentColor ? transparentColor : Color.text.primary,
            "&:hover": {
                background: "transparent",
                opacity: 0.6,
            },
            ":active": {
                background: "transparent",
                opacity: 0.4,
            },
            ":disabled": {
                background: "transparent",
                opacity: 0.2,
                border: 'none',
            },
        } : {};
        return __assign(__assign(__assign({}, normalStyle), negativeStyle), transparentStyle);
    }, [transparentColor]);
    return (_jsx(IconButton, __assign({ id: id }, rest, { disableRipple: true, sx: __assign(__assign(__assign(__assign({ width: (props === null || props === void 0 ? void 0 : props.width) || "auto", height: (props === null || props === void 0 ? void 0 : props.height) || "1.75rem" }, MarginProps(props)), PaddingProps(props)), { justifyContent: "center", alignItems: "center", gap: "0.25rem", flexShrink: 0, borderRadius: "0.25rem" }), CustomBackgroundColor({ color: color, transparent: transparent, border: border })), children: children ?
            cloneElement(children, { width: "16px", height: "16px" }) :
            iconName ?
                _jsx(Icon, { iconName: 'Apple' }) :
                null })));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
